import { BM_WIDGET_LOCALE, PROGRESS } from 'config/config';
import { getContainerHeight, trimLanguageTag } from 'helpers/commonHelper';
import withLocaleContext from 'hoc/withLocaleContext';
import React, { createRef, PureComponent, RefObject } from 'react';
import { FormattedMessage } from 'react-intl';

import { withRouter } from 'react-router-dom';
import { ICardProps, ICardWidget } from '../Card.types';
import { BMCardFrame, Container, ErrorContainer } from './CardBM.styles';
import withCardContext from '../../../hoc/withCardContext';
import { ICardContext } from '../../../types/CardContext';
import withContext from '../../../hoc/withContext';
import withTextContext from '../../../hoc/withTextContext';

interface IState {
  errorType: string;
  widgetLoaded: boolean;
}

class CardBM extends PureComponent<ICardProps & ICardWidget & ICardContext, IState> {
  containerRef: RefObject<HTMLDivElement> = createRef();

  bmWidgetRef: RefObject<HTMLIFrameElement> = createRef();

  constructor(props) {
    super(props);
    this.state = {
      errorType: '',
      widgetLoaded: false,
    };
  }

  componentDidMount() {
    const { setHeight } = this.props;
    setHeight(getContainerHeight(this.containerRef.current));

    window.addEventListener('message', this.handleBMCardFrameEvent);
  }

  componentDidUpdate() {
    const { widgetLoaded } = this.state;
    const { setHeight, setIsCardComponentLoading } = this.props;

    setHeight(getContainerHeight(this.containerRef.current));
    if (widgetLoaded) {
      this.updateWidgetLocale();
      setIsCardComponentLoading(false);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleBMCardFrameEvent);
  }

  getWidgetProviderUrl(): string {
    const { widgetUrl } = this.props;
    if (widgetUrl) {
      return widgetUrl;
    }

    return '';
  }

  handleBMCardFrameEvent = (e: MessageEvent) => {
    if (e.origin && this.getWidgetProviderUrl() && this.isInvalidEventOrigin(e.origin, this.getWidgetProviderUrl())) {
      return;
    }

    const { setProgress, setFormData } = this.props;
    const { status, message } = JSON.parse(e.data);
    switch (status) {
      case 'IS_VALIDATED': {
        setProgress(PROGRESS.CARD_BM_PAYMENT_TOKEN_PENDING);
        break;
      }
      case 'PAYMENT_TOKEN': {
        setFormData({ paymentMethodToken: message });
        setProgress(PROGRESS.CARD_BM_PAYMENT_TOKEN_SUCCESS);
        this.setState({ errorType: '' });
        break;
      }
      case 'WIDGET_ERROR': {
        this.setState({ errorType: status });
        setProgress(PROGRESS.CARD_BM_PAYMENT_TOKEN_FAILURE);
        break;
      }
      default: {
        break;
      }
    }
  };

  isInvalidEventOrigin = (eventOrigin: string, widgetOrigin: string) => {
    try {
      return new URL(eventOrigin).hostname !== new URL(widgetOrigin).hostname;
    } catch (e) {
      return true;
    }
  };

  setWidgetLoaded = () => {
    this.setState({
      widgetLoaded: true,
    });
  };

  updateWidgetLocale = () => {
    const { locale } = this.props;
    if (this.bmWidgetRef.current && this.bmWidgetRef.current.contentWindow && this.getWidgetProviderUrl()) {
      this.bmWidgetRef.current.contentWindow.postMessage(
        `{"status": "languageChanged", "message": "${BM_WIDGET_LOCALE[trimLanguageTag(locale)]}"}`,
        this.getWidgetProviderUrl()
      );
    }
  };

  render() {
    const { errorType } = this.state;

    return (
      <Container isValid={!errorType} className="card-component__bm-container" ref={this.containerRef}>
        <BMCardFrame
          ref={this.bmWidgetRef}
          className="card-component__bm-widget"
          src={`${this.getWidgetProviderUrl()}`}
          width="280"
          height="250"
          sandbox="allow-forms allow-scripts allow-same-origin"
          onLoad={this.setWidgetLoaded}
        />
        {!!errorType && (
          <ErrorContainer>
            <FormattedMessage id="paymentMethod.description.method_disabled" />
          </ErrorContainer>
        )}
      </Container>
    );
  }
}

export default withContext(withTextContext(withLocaleContext(withCardContext(withRouter(CardBM)))));
